import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Spinner,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import { validationSchema } from './validationSchema';

interface EditChatModalProps {
  isOpen: boolean;
  onClose: () => void;
  chatId?: string;
  currentTitle?: string;
  onSave: (chatId: string, title: string) => Promise<void>;
  isLoading?: boolean;
}

export const EditChatModal = ({
  isOpen,
  onClose,
  chatId,
  currentTitle,
  onSave,
  isLoading = false,
}: EditChatModalProps) => {
  const formik = useFormik({
    initialValues: {
      title: currentTitle || '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (chatId) {
        try {
          await onSave(chatId, values.title.trim());
          onClose();
        } catch (error) {
          console.error('Error updating chat title:', error);
        }
      }
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      motionPreset="slideInBottom"
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        borderRadius={'4px'}
        boxShadow="0px 0px 14px rgba(0, 0, 0, 0.1)"
        fontFamily={'inter'}
      >
        <ModalCloseButton onClick={onClose} />
        <form onSubmit={formik.handleSubmit}>
          <ModalBody p={4} mt={3}>
            <FormControl
              isInvalid={!!formik.errors.title && formik.touched.title}
            >
              <FormLabel color="text.secondary2" fontWeight="500">
                Chat Title
              </FormLabel>
              <Input
                placeholder="Enter chat title"
                id="title"
                name="title"
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isDisabled={isLoading}
              />
              {formik.errors.title && formik.touched.title && (
                <FormErrorMessage fontSize={'12px'}>
                  {formik.errors.title}
                </FormErrorMessage>
              )}
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              color={'text.secondary2'}
              p={'12px 16px'}
              bg={'transparent'}
              onClick={onClose}
              fontSize={'16px'}
              fontWeight={500}
              _hover={{ bg: 'white' }}
              isDisabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              ml={'8px'}
              color={'white'}
              p={'12px 16px'}
              bg={'primary'}
              border={'1px solid #E0E0E0'}
              borderRadius={'4px'}
              fontSize={'16px'}
              fontWeight={500}
              _hover={{ bg: 'primary' }}
              w={20}
              type="submit"
              isDisabled={!formik.isValid || isLoading || !formik.dirty}
            >
              {isLoading ? <Spinner size="sm" /> : 'Save'}
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default EditChatModal;
